exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2ed6a14a] .el-table tr{height:56px}\n", ""]);

// exports
